export interface InvoiceListLinkState {
  hasRelatedInvoice?: boolean;
}

/**
 * `hasRelatedInvoice` is supplied by the invoice-list API and is the canonical
 * signal that an invoice list has already been attached to an invoice.
 */
export const isInvoiceLinkedStatement = (
  statement?: InvoiceListLinkState | null,
): boolean => statement?.hasRelatedInvoice === true;
